import { Component, OnInit } from '@angular/core';
import { Bando } from '../../models/bando';
import { Router } from '@angular/router';
import { LoaderService } from '../../service/loader.service';
import { RestService } from '../../service/rest.service';
import { Location } from '@angular/common';
import { Message } from '../../service/message.service';
import { api, environment } from '../../../environments/environment';
import { SeoService } from '../../service/seo.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-bando',
  templateUrl: './bando.component.html',
  styles: [],
  standalone: false
})
export class BandoComponent implements OnInit {
  constructor(private rest: RestService,private http:HttpClient, private loader: LoaderService, private router: Router, private location: Location, private message: Message, private seo: SeoService) { }

  modalVerification = false
  accepted = false
  indexSelected = -1
  bandoDetails: any = {
  }
  showModalManulVerification = false
  categories: any = []
  motivation = ''
  reasoning: string = ''
  user = JSON.parse(localStorage.getItem('user') ?? '{}')
  isDev = !environment.production

  ngOnInit(): void {
    this.loader.on()
    this.loader.on()
    this.rest.get('/notice/by_slug/' + window.location.pathname.split('/')[2]).subscribe({
      next: (res: any) => {
        res.open = new Date(res.endDate) > new Date()
        let timeOpen = ` - ${new Date(res.startDate).getUTCHours()}:${new Date(res.startDate).getUTCMinutes() < 10 ? '0' + new Date(res.startDate).getUTCMinutes() : new Date(res.startDate).getUTCMinutes()}`
        res.startDate = new Date(res.startDate).getDate() + '/' + (new Date(res.startDate).getMonth() + 1) + '/' + new Date(res.startDate).getFullYear() + (new Date(res.startDate).getUTCHours() > 0 ? timeOpen : '')
        res.endDate = new Date(res.endDate).getDate() + '/' + (new Date(res.endDate).getMonth() + 1) + '/' + new Date(res.endDate).getFullYear()
        if (res.stanziamentoIncentivo) {
          res.stanziamentoIncentivo = this.formatNumber(res.stanziamentoIncentivo.replace('.00', ''))
          res.stanziamentoIncentivoNumber = parseInt(res.stanziamentoIncentivo.replaceAll('.', ''))
          let containerWeb = document.getElementById('container-web')
          // setTimeout(() => {
          //   if (containerWeb) {

          //     let cardPrice = document.getElementById('card-price')
          //       if (cardPrice) {

          //         cardPrice.style.bottom = (1250) + 'px'
          //       }
          //   }
          // }, 100);  

          //   if (containerWeb) {

          //     containerWeb.addEventListener('scroll', (event: any) => {
          //       let cardPrice = document.getElementById('card-price')
          //       if (cardPrice) {
          //         cardPrice.style.bottom = (1250 - event.target.scrollTop) + 'px'
          //       }
          //     })
          //   }
        }
        res.desc1 = this.formattaTesto(res.desc1)
        res.desc2 = this.formattaTesto(res.desc2)
        res.desc3 = this.formattaTesto(res.desc3)
        res.description = this.formattaTesto(res.description)
        this.bandoDetails = res
        this.seo.updateSeo({
          titleSeo: res.title,
          metadescription: res.summary || res.description
        });
        this.rest.get('/notice/' + this.bandoDetails.id + '/categories').subscribe({
          next: (res: any) => {
            this.categories = res
            this.loader.off()
          },
          error: (value: any) => {
            this.loader.off()
          },
        })
        this.loader.off()
      },
      error: (value: any) => {
        this.loader.off()
      },
    })

  }

  formattaTesto(testo: string) {
    if (testo) {
      return testo
        .replace(/\s+/g, ' ')
        .replace(/([.!?])\s+([A-ZÀ-Ý])/g, '$1\n\n$2')
        .replace(/\s*•\s*/g, '\n• ')
        // .replace(/\s*:\s*/g, ':\n\n ')
        .trim();
    } else {
      return testo
    }
  }

  showModalVerification() {
    this.loader.on()
    this.rest.get('/notice/' + this.bandoDetails.id + '/evaluate').subscribe({
      next: (value: any) => {
        this.loader.off()
        this.reasoning =value.success ? value?.aiEvaluation?.reasoning : 'Errore generico'
        if (value?.aiEvaluation?.canParticipate) {
          this.accepted = true
          this.modalVerification = true

        } else {

          this.motivation = value.success ? value?.aiEvaluation?.motivation : 'Non sei ammissibile'
          this.modalVerification = true
          this.message.showMessage(value?.aiEvaluation?.motivation ? value?.aiEvaluation?.motivation : 'Non sei ammissibile per questo bando contattaci per rimediare', 'error')
        }
      },
      error: (value) => {
        this.message.showMessage('Non sei ammissibile per questo bando', 'error')
        this.loader.off()
      },
    })
  }

  goToContact() {
    window.location.replace('contatti')
  }

  join(id: number) {
    this.loader.on()
    this.modalVerification = false
    this.rest.get('/notice/join/' + id).subscribe({
      next: (value: any) => {
        this.message.showMessage('Ti sei unito al progetto', 'success')
        this.loader.off()
        window.location.replace('/progetto/' + value.projectId)
      },
      error: (value: any) => {
        if (value.status == 409) {
          this.message.showMessage(value.error.message, 'error')
        }
        this.loader.off()
      },
    })
  }

  downloadBando(){
    this.loader.on()
    this.http.get(`${api.baseUrl}/notice/${this.bandoDetails.id}/pdf`, {
      responseType: "blob",
      headers: {
        Authorization: `${api.prefixAuthorization} ${localStorage.getItem(
          'token'
        )}`,
      },
    }).subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = this.bandoDetails.slug+".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.loader.off(true);
      });
  }

  goBack() {
    this.router.navigate(['/cerca-bando']);
  }

  goTo() {
    if (localStorage.getItem('token')) {
      if (JSON.parse(localStorage.getItem('user') ?? '')?.planId) {
        this.showModalVerification()
        let containerWeb = document.getElementById('container-web')
        if (containerWeb) {
          containerWeb.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      } else {
        if(JSON.parse(localStorage.getItem('user') ?? '')?.role == 6){
          this.message.showMessage('I partner non possono fare verifica ammissibilità', 'error')
        }else{
        this.message.showMessage('Per verificare la tua ammissibilità devi essere abbonato', 'error')}
      }
    } else {
      this.router.navigate(['login'])
    }
  }

  goBandoDetails(id: string) {
    this.router.navigate(['/dettaglio-bando-admin/' + id])
  }

  formatNumber(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}
